import { FILTER_CONFIG, PAYLOAD_TYPES } from "../components/filters/FilterConfig";

/**
 * Senior Dev Note: Pure logic file. 
 * This keeps the "Math" of converting UI -> API separate from React.
 */
export const filterService = {
  /**
   * Transforms the UI state object into the DTO array the .NET Backend expects.
   * @param {Object} activeFilterState - e.g., { DEPARTMENT: {id: 1}, CLIENT: null }
   * @param {Array} maintenanceTypes - e.g., [{ name: "DEPARTMENT", value: 5 }, ...]
   * @returns {Array} - e.g., [{ type: 5, value: 1 }]
   */
  prepareMaintenancePayload: (activeFilterState, maintenanceTypes) => {
    if (!maintenanceTypes || maintenanceTypes.length === 0) return [];

    return Object.keys(activeFilterState)
      .filter((key) => {
        const config = FILTER_CONFIG[key];
        // Only include if it's NOT additional AND has a value
        return config?.payloadType !== PAYLOAD_TYPES.ADDITIONAL && activeFilterState[key] !== null;
      })
      .map((key) => {
        const enumInfo = maintenanceTypes.find((e) => e.name === key);

        return {
          type: enumInfo ? enumInfo.value : 0, // The ID from DROPDOWN_TYPES
          value: activeFilterState[key]?.id,    // The ID of the selected item (e.g. Dept ID)
        };
      })
      .filter((f) => f.type !== 0); // Remove unmapped enums
  },

  prepareAdditionalPayload: (activeFilterState) => {
    const additional = {};

    Object.keys(activeFilterState).forEach((key) => {
      const config = FILTER_CONFIG[key];
      const value = activeFilterState[key];

      if (config?.payloadType === PAYLOAD_TYPES.ADDITIONAL && value) {
        const apiKey = config.payloadKey || key;
        // If it's a static select object, take the id, otherwise take the raw value (for dates/text)
        additional[apiKey] = value?.id !== undefined ? value.id : value;
      }
    });

    return additional;
  },

  /**
   * Maps UI Filter State to Salary Rule Details
   * @param {Object} activeFilterState - { DEPARTMENT: {id: 1}, POSITION: {id: 10} }
   * @param {Array} maintenanceTypes - [{ name: "DEPARTMENT", value: 5 }, ...]
   * @returns {Array} - [{ maintenanceTypeId: 5, maintenanceValueId: 1 }, ...]
   */
  mapFiltersToRuleDetails: (activeFilterState, maintenanceTypes) => {
    if (!maintenanceTypes || maintenanceTypes.length === 0) return [];

    return Object.keys(activeFilterState)
      .filter((key) => activeFilterState[key] !== null)
      .map((key) => {
        const enumInfo = maintenanceTypes.find((e) => e.name === key);
        return {
          maintenanceTypeId: enumInfo ? enumInfo.value : null,
          maintenanceValueId: activeFilterState[key]?.id || null,
        };
      })
      .filter((detail) => detail.maintenanceTypeId !== null);
  }
};